import React from 'react';
import './Dashboard.css';

import { navLinks } from './navLinks';
import fullLogo from '../../assets/images/full-logo-fatturami.svg';


function Dashboard() {
    return (
        <main className="page-dashboard">

            {/* Header */}
            <div className='header'>
                <div style={{ display: 'flex' }}>
                    <img src={fullLogo} className="logo" alt="Logo" />
                </div>
                <span className="dashboard-subtitle">
                    Benvenuto! Scegli una funzionalità per iniziare
                </span>
            </div>

            {/* Cards Grid */}
            <div className="cards-grid">
                {navLinks.map(link =>
                    <a
                        key={link.url}
                        href={link.url}
                        className={`card ${link.legacy ? 'card-legacy' : ''}`}
                    >
                        {link.icon}
                        <span className="title" >
                            {link.title}
                        </span>
                        <span className="description">
                            {link.description}
                        </span>
                        {link.legacy && (
                            <>
                            <div className="legacy-overlay" />
                            <div className="legacy-badge">
                                Legacy
                            </div>
                            </>
                        )}
                    </a>
                )}
            </div>

            {/* Placeholder KPI */}
            <div className="coming-soon">
                <span className='title'>
                    Prossimamente: Dashboard con KPI e riepilogo
                </span>
                <ul className="kpi-list">
                    <li>Indicatori chiave sulle attività svolte (ad es. numero F24 estratti)</li>
                    <li>Statistiche aggregate su periodi e clienti</li>
                    <li>Riepilogo delle informazioni estratte organizzato per partita IVA/cliente</li>
                    <li>Accesso rapido alle analisi dettagliate derivanti dai tool</li>
                </ul>
                <span className='description' >
                    La dashboard sarà il punto di partenza per monitorare in tempo reale la situazione fiscale dei tuoi clienti.
                </span>
            </div>

        </main>
    );
}

export default Dashboard;
